import { DataValidationError } from "constants/DataValidationError";
import { IsNotEmpty } from "class-validator";

export default class DeleteAreaReq {
  @IsNotEmpty({
    message: DataValidationError.DATA_IS_EMPTY,
  })
  readonly areaId: number;

  constructor(arg: any) {
    arg = arg || {};
    this.areaId = arg.areaId;
  }
}
